import React, { Component } from 'react';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Titulo from '../comum/Titulo';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import qs from 'qs';
import buscarMapaVeiculoAgendamentoViagemPoltrona from '../../actions/agendamento-viagem/buscarMapaVeiculoAgendamentoViagemPoltrona';
import buscarAgendamentoViagem from '../../actions/agendamento-viagem/buscarAgendamentoViagem';
import MapaVeiculoAgendamentoViagem from './MapaVeiculoAgendamentoViagem';
import selecionarMapaVeiculoAgendamentoViagem from '../../actions/agendamento-viagem/selecionarMapaVeiculoAgendamentoViagem';
import moment from 'moment';
import ModalCadastrarPassageiroAgendamentoViagem from './ModalCadastrarPassageiroAgendamentoViagem';
import excluirAgendamentoViagemPassageiro from '../../actions/agendamento-viagem/excluirAgendamentoViagemPassageiro';
import { showSuccessMsg } from '../../util/messagesUtil';
import limparSelecaoMapaVeiculoAgendamentoViagem from '../../actions/agendamento-viagem/limparSelecaoMapaVeiculoAgendamentoViagem';
import { formatarReal, realParaNumber } from '../../util/numberUtil';

const ModalConfirmacaoExclusaoPasageiroAgendamentoViagem = ({excluir, limpar}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoPasageiroAgendamentoViagem" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir Passageiro selecionado?</p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal" 
                            onClick={() => limpar()}
                            >Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelPassageirosAgendamentoViagem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            andarSelecionado: 1,
            passageiros: [],
            passageiroAgendamentoViagemSelecionado: null,
            valorTotal: 0
        }
    }

    assentosSelecionados(andar) {
        let assentosSelicionado = []
        if (this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar && andar == 1) {
            assentosSelicionado = this.retornarAssentos(this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar);
        } else if (this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar && andar == 2) {
            assentosSelicionado = this.retornarAssentos(this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar);
        }

        return assentosSelicionado
    }

    retornarAssentos(fileiras) {
        let assentosSelicionado = [];
        fileiras.forEach(fileira => {
            fileira.assentos.forEach(assento => {
                if (assento.selecionado) {
                    assentosSelicionado.push(assento)
                }
            })
        });

        return assentosSelicionado;
    }

    exibirBotaoAdicionarPassageiros(andar) {
        if (this.assentosSelecionados(andar).length > 0) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button data-toggle="modal"
                                data-target="#modalCadastrarPassageiroAgendamentoViagem"
                                className="btn btn-laranja" onClick={() => this.setState({ andarSelecionado: andar })}>
                                Adicionar
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
        return ''

    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.agendamento) {
            this.props.buscarMapaVeiculoAgendamentoViagemPoltrona(parametros.agendamento, this.props.empresaSelecionada.id);
            this.props.buscarAgendamentoViagem(parametros.agendamento, this.props.empresaSelecionada.id);
        }

    }

    adicionarPassageiro(assento, fileira) {
        let passageiros = [...this.state.passageiros];

        if (assento.selecionado) {
            passageiros = passageiros.filter(it => it.poltronaId != assento.poltrona.id);
        } else {
            passageiros.push({
                assento: assento,
                fileira: fileira,
                poltronaId: assento.poltrona.id,
                numeroPoltrona: assento.poltrona.numero,
                nome: '',
                telefone: '',
                cpf: null,
                rg: '',
                valor: 0,
                pix: false,
                cartao: false,
                dinheiro: false

            });
        }

        this.setState({ passageiros });
        this.props.selecionarMapaVeiculoAgendamentoViagem(assento, fileira);
    }

    atualizarPasageiro(passageiroParam) {
        const passageiros = [...this.state.passageiros];
        const passageiroCorrente = passageiros.find(f => f.poltronaId === passageiroParam.poltronaId);
        const indice = passageiros.indexOf(passageiroCorrente);
        const passageiroNovo = Object.assign({}, passageiroCorrente, { ...passageiroParam });
        const copiaListaPassageiros = Object.assign([], passageiros);
        copiaListaPassageiros[indice] = passageiroNovo;
        
        this.setState({ passageiros: copiaListaPassageiros });
    }

    removerPassageiro(assento, fileira, andarSelecionado, callbackFecharModal) {
        const passageiros = [...this.state.passageiros];
        const passageirosFiltrados = passageiros.filter(it => it.poltronaId !== assento.poltrona.id );
        this.setState({ passageiros: passageirosFiltrados });
        this.props.selecionarMapaVeiculoAgendamentoViagem(assento, fileira);

        if(passageirosFiltrados.filter(p =>  p.assento.poltrona.andar === andarSelecionado).length <= 0 && callbackFecharModal) {            
            this.props.limparSelecaoMapaVeiculoAgendamentoViagem(andarSelecionado);
            callbackFecharModal();
        }
    }

    limparPassageiros() {
        this.setState({ passageiros: [] });
    }

    calcularValorTotal() {
        let fileiras = [];
        let valorTotal = 0;
        
        if (this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar) {
            fileiras = this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar;
            fileiras.forEach(f => f.assentos.forEach(assento => {
                if (assento.poltrona && assento.poltrona.agendamentoViagemComPassageiro) { 
                    valorTotal += realParaNumber(assento.poltrona.agendamentoViagemPassageiroDto.valor);
                }
            }));
        }
        
        if(this.props.mapaVeiculoAgendamentoViagem.seDoisAndares) {
            if (this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar) {
                fileiras = this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar;
                fileiras.forEach(f => f.assentos.forEach(assento => {
                    if (assento.poltrona && assento.poltrona.agendamentoViagemComPassageiro) { 
                        valorTotal += realParaNumber(assento.poltrona.agendamentoViagemPassageiroDto.valor);
                    }
                }));
            }
        }

        return valorTotal;
    }

    exibirListaPassageiros(andar) {
        const passageiros = [];
        let fileiras = [];

        let titulo = 'Lista de Passageiros';
        if(this.props.mapaVeiculoAgendamentoViagem.seDoisAndares) {
            titulo = `Lista de Passageiros do ${andar}° Andar`;
        }

        if (this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar && andar == 1) {
            fileiras = this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar;
        } else if (this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar && andar == 2) {
            fileiras = this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar;
        }

        fileiras.forEach(f =>
            f.assentos.forEach(assento => {
                if (assento.poltrona && assento.poltrona.agendamentoViagemComPassageiro) {
                    const agendamentoViagemPassageiro = assento.poltrona.agendamentoViagemPassageiroDto;
                    const passageiro = agendamentoViagemPassageiro.passageiroDto;
                    passageiros.push({
                        poltronaId: assento.poltrona.id,
                        numeroPoltrona: assento.poltrona.numero,
                        pedidoId: agendamentoViagemPassageiro.pedidoId,
                        valor: agendamentoViagemPassageiro.valor,
                        id: agendamentoViagemPassageiro.id,
                        passageiroId: passageiro.id,
                        nome: passageiro.nome,
                        rg: passageiro.documentoComFoto,
                        tipoDocumento: passageiro.tipoDocumento,
                        telefone: passageiro.telefone,
                        cpf: passageiro.cpfPassageiro,
                        dtNascimento: passageiro.dtNascimento                        
                    });
                }
            }));
        if (passageiros.length) {
            return <div className='table-responsive'> <table className="table table-sm table-striped  table-bordered text-center page-break mt-4" style={{ backgroundColor: '#FFF' }}>
                <thead>
                    <tr>
                        <td colSpan={10}>                            
                            <strong>{titulo}</strong>
                        </td>
                    </tr>
                    <tr>                        
                        <th scope="col">Pedido</th>
                        <th scope="col">Poltrona</th>
                        <th scope='col'>CPF</th>
                        <th scope='col'>RG</th>
                        <th scope="col">Nome</th>                        
                        <th scope='col'>Dt. Nascimento</th>
                        <th scope='col'>Telefone</th>
                        <th scope='col'>Valor</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {passageiros.sort((a,b) => a.pedidoId - b.pedidoId).map(it =>
                        <tr key={`tbl-passageiro-${it.id}`}>                            
                            <td>
                                <span>{it.pedidoId}</span>
                            </td>
                            <td>
                                <span>{it.numeroPoltrona}</span>
                            </td>
                            <td>
                                <span>{it.cpf}</span>
                            </td>
                            <td>
                                <span>{it.rg}</span>
                            </td>
                            <td>
                                <span>{it.nome}</span>
                            </td>                            
                            <td>
                                <span>{it.dtNascimento}</span>
                            </td>
                            <td>
                                <span>{it.telefone}</span>
                            </td>
                            <td>
                                <span>
                                    {realParaNumber(it.valor).toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </span>
                            </td>
                            <td>
                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(this.props.empresaSelecionada.id),
                                    getAdminEmpresa(this.props.empresaSelecionada.id),
                                    getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                    <button type="button" className="btn btn-excluir"
                                        data-toggle="modal"
                                        data-target="#modalConfirmacaoExclusaoPasageiroAgendamentoViagem"
                                        title='Excluir'
                                        onClick={() => this.selecionarPassageiroAgendamentoViagem(it.id)}
                                        >
                                        <i className="material-icons nav-icon">&#xe872;</i>
                                    </button>
                                </Autorizacao>
                            </td>
                        </tr>)}
                </tbody>
            </table></div>
        }
    }

    selecionarPassageiroAgendamentoViagem(id) {
        this.setState({ passageiroAgendamentoViagemSelecionado: id });
    }

    excluirPassageiroAgendamentoViagemSelecionado() {
        this.props.excluirAgendamentoViagemPassageiro(this.state.passageiroAgendamentoViagemSelecionado, this.props.empresaSelecionada.id)
            .then(() => {
                this.props.buscarMapaVeiculoAgendamentoViagemPoltrona(this.props.agendamentoViagem.id, this.props.empresaSelecionada.id);
                showSuccessMsg('Os passageiros foi excluído com sucesso');
            })
    }

    limparPassageiroAgendamentoViagem() {
        this.setState({ passageiroAgendamentoViagemSelecionado: null });
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className="row internas">
                        <Titulo texto='Painel Passageiros Agendamento Viagem' urlRetorno="/painel-agendamento-viagem" />
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>

                            <div className="col-12 titulo-principal-componente">
                                <h1 id="titulo-page" className="text-center">{this.props.agendamentoViagem.veiculo.descricao}</h1>
                                <h4 id="titulo-page" className="text-center">{`Período ${moment(this.props.agendamentoViagem.dataInicio).format('DD/MM/YYYY')} à ${moment(this.props.agendamentoViagem.dataFim).format('DD/MM/YYYY')}`}</h4>
                                {this.props.agendamentoViagem.contratante ? <h1 id="titulo-page" className="text-center">Contratante: {this.props.agendamentoViagem.contratante.nome} </h1> : ''}
                                {!this.props.mapaVeiculoAgendamentoViagem.seDoisAndares && <h4 id="titulo-page" className="text-center"><p className="linha"></p></h4>}
                            </div>

                            <div className="row col-12 col-md-12 mt-4" ><h4>Valor Total: {formatarReal(this.calcularValorTotal().toString())}</h4></div>

                            {this.props.mapaVeiculoAgendamentoViagem.seDoisAndares && <><h4 id="titulo-page">1° Andar </h4><h4 id="titulo-page" className="text-center"><p className="linha"></p></h4></>}
                            <MapaVeiculoAgendamentoViagem
                                mapaVeiculo={this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar}
                                selecionar={this.adicionarPassageiro.bind(this)}
                            />
                            {this.exibirBotaoAdicionarPassageiros(1)}
                            {this.props.mapaVeiculoAgendamentoViagem.seDoisAndares
                                && <>
                                    <h4 id="titulo-page">2° Andar </h4>
                                    <h4 id="titulo-page" className="text-center"><p className="linha"></p></h4>
                                    <MapaVeiculoAgendamentoViagem
                                        mapaVeiculo={this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar}
                                        selecionar={this.adicionarPassageiro.bind(this)}
                                    /></>}
                            {this.exibirBotaoAdicionarPassageiros(2)}
                            {this.exibirListaPassageiros(1)}
                            {this.props.mapaVeiculoAgendamentoViagem.seDoisAndares && this.exibirListaPassageiros(2)}
                        </div>
                    </div>
                    <ModalCadastrarPassageiroAgendamentoViagem
                        andarSelecionado={this.state.andarSelecionado}
                        passageiros={this.state.passageiros}
                        agendamentoViagem={this.props.agendamentoViagem}
                        atualizarPasageiro={this.atualizarPasageiro.bind(this)}
                        removerPassageiro={this.removerPassageiro.bind(this)}
                        limparPassageiros={this.limparPassageiros.bind(this)}
                    />
                    <ModalConfirmacaoExclusaoPasageiroAgendamentoViagem 
                        excluir={this.excluirPassageiroAgendamentoViagemSelecionado.bind(this)} 
                        limpar={this.limparPassageiroAgendamentoViagem.bind(this)} />
                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        mapaVeiculoAgendamentoViagem: state.mapaVeiculoAgendamentoViagem,
        agendamentoViagem: state.agendamentoViagem
    });

export default withRouter(connect(mapStateToProps,
    {
        buscarMapaVeiculoAgendamentoViagemPoltrona,
        buscarAgendamentoViagem,
        selecionarMapaVeiculoAgendamentoViagem,
        excluirAgendamentoViagemPassageiro,
        limparSelecaoMapaVeiculoAgendamentoViagem
    })(reduxForm({
        form: 'formularioPassageirosAgendamentoViagem'
    })(PainelPassageirosAgendamentoViagem)))
